import type { PrintAgent as PrintAgentData } from '@mathflat/domain/RemotePrint'
import { makeObservable, observable } from 'mobx'

import { localStorageService } from '@/service/storage.service'

import { DTO } from '../DTO'

const GUID_REG_EXP = /^[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}$/i

export interface Printer {
  printerName: string // 프린터명 - 고유값
  printerModel: string // 프린터 모델
  machineId: string // 해당 PC ID
  machineName: string // PC명
  displayName: string // UI상 보여줄 프린터명
}

export class PrintAgent extends DTO {
  printerList: Printer[] = []
  selectedPrinter: Printer | null = null

  constructor(data: PrintAgentData[]) {
    super()
    makeObservable(this, {
      printerList: observable,
      selectedPrinter: observable,
    })

    data.forEach((agent, i) => {
      const transformedMachineName = GUID_REG_EXP.test(agent.machineName)
        ? `PC ${i + 1} (PC용앱 업데이트 필요)`
        : agent.machineName.slice(0, 20)

      agent.printers.forEach((print) => {
        if (!print) return

        this.printerList.push({
          machineId: agent.machineId,
          machineName: agent.machineName,
          printerName: print.name,
          printerModel: print.model,
          displayName: `[${transformedMachineName}]의 ${print.name}`,
        })
      })
    })

    const selectedPrinter = localStorageService.getItem('SELECTED_PRINTER')
    /**
     * 로컬스토리지에 선택했던 프린터 값이 있는 경우,
     * 받아온 프린트 리스트 중에서 machineId, displayName이 같은 프린트가 있으면
     * 해당 프린트를 default로 지정
     */
    const latestPrinter = this.printerList.find(
      ({ machineId, displayName }) =>
        machineId === selectedPrinter?.machineId && displayName === selectedPrinter.displayName,
    )

    this.selectedPrinter = latestPrinter ?? this.printerList[0]
  }
}
